import * as React from "react";
import { useTl, useApiService } from "../../../../hooks";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, useGridState, useSearchApi, FieldSet } from "nsitools-react";
import { CustomDataTable, ExportButton } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { PersonFilesApi, PersonFileSearch, PersonFileGridDto } from "../../../../api";
import { Link } from "react-router-dom";
import { getRouteStr } from "../../../../utils/RequestRouteUtil";
import { getSearchRouteStr } from "../../../../utils/RequestSearchRouteUtil";

export interface IPersonLinkedFilesProps {
  personId: number;
}

export const PersonLinkedFiles: React.FunctionComponent<IPersonLinkedFilesProps> = ({ personId }) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const api = useApiService(PersonFilesApi);
  const [sObjState, setsobjState] = React.useState<any>();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.RequestType),
        fieldName: "requestType",
        render: (row: PersonFileGridDto) => (
          <Link target="_blank" to={getSearchRouteStr(row.requestTypeCode)}>
            {row.requestType}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
        render: (row: PersonFileGridDto) => (
          <Link target="_blank" to={getRouteStr(row.requestTypeCode, row.subRequestId, "edit")}>
            {row.requestNumber}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Status),
        fieldName: "requestState",
      },
      {
        header: () => t(ETLCodes.RequestDate),
        fieldName: "requestDate",
      },
    ],
    [t]
  );

  const tableState = useGridState({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { requestDate: "DESC" },
  });

  const searchFunction = React.useCallback(
    (sObj: PersonFileSearch) => {
      const sobj = PersonFileSearch.fromJS({
        ...sObj,
        personId: personId,
        languageId: currentLanguage.languageId,
      });
      setsobjState(sobj);
      return api.baseSearch(sobj);
    },
    [api, currentLanguage.languageId, personId]
  );

  const { search, loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <FieldSet rightElement={<ExportButton exportFunction={(sObj) => api.exportXlsFile(sObj)} sObj={sObjState} />}>
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
